import { render, staticRenderFns } from "./promotions-product-detail.vue?vue&type=template&id=532ab08b&scoped=true&"
import script from "./promotions-product-detail.vue?vue&type=script&lang=js&"
export * from "./promotions-product-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotions-product-detail.vue?vue&type=style&index=0&id=532ab08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ab08b",
  null
  
)

export default component.exports